export default __webpack_public_path__ + "static/media/upload-character.e2817e01.png";